import React from 'react';
import {Table, Input, Button, Icon} from 'antd';
import {UUID_NULL} from '../constants/defaultValues'
import {locdau} from '../utils'

const getGroupNames = (stations) => {
  const values = stations.filter(item => (item.GroupName)).map((item) => {
    return {text: item.GroupName, value: item.GroupID}
  }).filter((s, index, arr) => arr.findIndex((t) => {
    return (t.value === s.value)
  }) === index)
  return values.concat({text: "Chưa cài đặt", value: UUID_NULL})
}

const highlight = {
  color: '#68be57'
}

class StationTableNonAction extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      stations: this.props.stations,
      selectedRowKeys: this.props.selectedKeys,
      nameFilterVisible: false,
      nameSearchText: '',
      nameFiltered: false,
      hardwareIDFilterVisible: false,
      hardwareIDSearchText: '',
      hardwareIDFiltered: false
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.selectedKeys.toString() !== this.props.selectedKeys.toString()) {
      this.setState({stations: nextProps.stations, selectedRowKeys: nextProps.selectedKeys})
    }
  }

  onSelectChange = (selectedRowKeys) => {
    this.props.onSelectedKeys(selectedRowKeys)
    this.setState({selectedRowKeys});
  }

  handleNameInputChange = (e) => {
    this.setState({nameSearchText: e.target.value});
  };

  handleNameSearch = () => {
    const {nameSearchText, selectedRowKeys} = this.state
    const {stations} = this.props
    const filterStations = stations.filter((item) => {
      const kodau = locdau(item.Name).toLowerCase()
      const kodauSearch = locdau(nameSearchText).toLowerCase()
      const index = kodau.indexOf(kodauSearch);
      const selectedIndex = selectedRowKeys.findIndex((key) => {
        return key === item.ID
      })
      return index > -1 || selectedIndex > -1
    }).map((item) => {
      const kodau = locdau(item.Name).toLowerCase()
      const kodauSearch = locdau(nameSearchText).toLowerCase()
      const index = kodau.indexOf(kodauSearch);
      const beforeStr = index > -1
        ? item.Name.substr(0, index)
        : item.Name;
      const matchStr = index > -1
        ? item.Name.substr(index, nameSearchText.length)
        : "";
      const afterStr = index > -1
        ? item.Name.substr(index + nameSearchText.length)
        : "";
      const title = (<span>
        {beforeStr}
        <span className="highlight">{matchStr}</span>
        {afterStr}
      </span>)
      return {
        ...item,
        Title: title
      };
    })

    this.setState({
      nameFilterVisible: false,
      nameFiltered: !!nameSearchText,
      hardwareIDFiltered: false,
      hardwareIDSearchText: "",
      stations: filterStations
    });
  };

  handleHardwareIDInputChange = (e) => {
    this.setState({hardwareIDSearchText: e.target.value});
  };

  handleHardwareIDSearch = () => {
    const {hardwareIDSearchText, selectedRowKeys} = this.state
    const {stations} = this.props
    const filterStations = stations.filter((item) => {
      const lower = item.HardwareIDHex.toLowerCase()
      const lowerSearch = hardwareIDSearchText.toLowerCase()
      const selectedIndex = selectedRowKeys.findIndex((key) => {
        return key === item.ID
      })
      const index = lower.indexOf(lowerSearch);
      return index > -1 || selectedIndex > -1
    }).map((item) => {
      const lower = item.HardwareIDHex.toLowerCase()
      const lowerSearch = hardwareIDSearchText.toLowerCase()
      const index = lower.indexOf(lowerSearch);
      const beforeStr = index > -1
        ? item.HardwareIDHex.substr(0, index)
        : item.HardwareIDHex;
      const matchStr = index > -1
        ? item.HardwareIDHex.substr(index, hardwareIDSearchText.length)
        : "";
      const afterStr = index > -1
        ? item.HardwareIDHex.substr(index + hardwareIDSearchText.length)
        : "";
      const title = (<span>
        {beforeStr}
        <span className="highlight">{matchStr}</span>
        {afterStr}
      </span>)
      return {
        ...item,
        HardwareIDTitle: title
      };
    })
    this.setState({
      hardwareIDFilterVisible: false,
      hardwareIDFiltered: !!hardwareIDSearchText,
      nameFiltered: false,
      nameSearchText: "",
      stations: filterStations
    });
  };

  render() {
    const {fetching, groups} = this.props
    const {
      stations,
      selectedRowKeys,
      nameFiltered,
      nameSearchText,
      nameFilterVisible,
      hardwareIDFiltered,
      hardwareIDSearchText,
      hardwareIDFilterVisible
    } = this.state
    const rowSelection = {
      selectedRowKeys,
      onChange: this.onSelectChange
    };
    const filterGroupNames = getGroupNames(stations)
    const columns = [
      {
        title: 'Tên',
        dataIndex: 'Name',
        render: (text, station, i) => (
          station.Title
          ? station.Title
          : station.Name),
        key: 'name',
        filterDropdown: (<div className="table-filter-dropdown">
          <Input ref={ele => this.nameSearchInput = ele} placeholder="Nhập tên" value={nameSearchText} onChange={this.handleNameInputChange} onPressEnter={this.handleNameSearch}/>
          <Button type="primary" onClick={this.handleNameSearch}>Tìm</Button>
        </div>),
        filterIcon: <Icon type="search" style={nameFiltered
            ? highlight
            : null}/>,
        filterDropdownVisible: nameFilterVisible,
        onFilterDropdownVisibleChange: visible => this.setState({
          nameFilterVisible: visible
        }, () => this.nameSearchInput.focus())
      }, {
        title: 'Mã',
        dataIndex: 'HardwareIDHex',
        render: (text, station, i) => (
          station.HardwareIDTitle
          ? station.HardwareIDTitle
          : station.HardwareIDHex),
        key: 'hardwareidhex',
        filterDropdown: (<div className="table-filter-dropdown">
          <Input ref={ele => this.hardwareIDSearchInput = ele} placeholder="Nhập mã" value={hardwareIDSearchText} onChange={this.handleHardwareIDInputChange} onPressEnter={this.handleHardwareIDSearch}/>
          <Button type="primary" onClick={this.handleHardwareIDSearch}>Tìm</Button>
        </div>),
        filterIcon: <Icon type="search" style={hardwareIDFiltered
            ? highlight
            : null}/>,
        filterDropdownVisible: hardwareIDFilterVisible,
        onFilterDropdownVisibleChange: visible => this.setState({
          hardwareIDFilterVisible: visible
        }, () => this.hardwareIDSearchInput.focus())
      }, {
        title: 'Địa bàn',
        dataIndex: 'GroupName',
        key: 'groupname',
        filters: filterGroupNames,
        onFilter: (value, record) => (record.GroupID === value)
      }
    ];
    return <Table columns={columns} dataSource={stations} rowKey={station => station.ID} rowSelection={rowSelection} loading={fetching}/>
  }
}

export default StationTableNonAction



// WEBPACK FOOTER //
// ./src/components/StationTableNonAction.js